import React, {FunctionComponent} from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {useAppDispatch} from "../../../store/AppStore";
import {Menu, MenuItem} from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import PersonIcon from "@mui/icons-material/Person";
import Typography from "@mui/material/Typography";
import {AppRoute} from "../../../book/AppRoute";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import {userLogoutAction} from "../../../action/UserLogoutAction";

export const AppbarUserMenu: FunctionComponent<AppbarUserMenuProps> = props => {
    const {t} = useTranslation();
    const dispatch = useAppDispatch();

    return <Menu
        anchorEl={props.anchorEl}
        open={props.isOpen}
        keepMounted
        onClose={props.handleClose}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        anchorOrigin={{vertical: 'top', horizontal: 'right'}}>
        <MenuItem component={Link} to={AppRoute.Profile}>
            <ListItemIcon>
                <PersonIcon/>
            </ListItemIcon>
            <Typography variant="inherit">{t("Profile")}</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
            dispatch(userLogoutAction());
        }}>
            <ListItemIcon>
                <ExitToAppIcon/>
            </ListItemIcon>
            <Typography variant="inherit">{t("Sign out")}</Typography>
        </MenuItem>
    </Menu>;
}

export interface AppbarUserMenuProps {
    isOpen: boolean;
    anchorEl: HTMLElement | null;
    handleClose: () => void;
}